export const getLevelFormworkBenchLengthValidity = (
  formworkBenchLength: number | undefined,
  maxFormworkBenchLength: number
): boolean => formworkBenchLength === undefined || formworkBenchLength <= maxFormworkBenchLength;
